<!-- Audience Network native -->
<div class="anp ann">
  <a class="anp-link ann-unit" [attr.href]="data.url || null" target="_blank" rel="noopener noreferrer">
    <div class="ann-header">
      <img class="ann-avatar" [src]="avatar" alt="" />
      <div class="ann-identity">
        <div class="ann-name">{{ pageName }}</div>
        <div class="ann-label">Oglas</div>
      </div>
      <i class="bi bi-info-circle ann-icon"></i>
      <i class="bi bi-play ann-icon ann-choices"></i>
    </div>

    <app-meta-creative class="ann-creative" [src]="data.creative" [kind]="data.creativeKind" slot="fit"></app-meta-creative>

    <div class="ann-headline">{{ headline }}</div>
    <div class="ann-text">{{ primaryText }}</div>
    <span class="ann-cta">{{ cta }}</span>
  </a>

  <div class="anp-note">
    <p class="anp-note-lead">Ads on the Audience Network are shown in third-party mobile apps and mobile websites.</p>
    <p>Please note, this is only a preview. The ad may show up differently in other apps and websites.</p>
  </div>
</div>
